import React from 'react'
import translatePath from './translatePath'

export const defaultX = 0
export const defaultY = 0
export const width = 550
export const height = 1150

export const path = [
  'M275,0 C426.878306,0 550,123.121694 550,275 C550,316.421356 516.421356,350 475,350 C433.992857,350 400.672357,317.089571 400.010048,276.240262 L400,275 C400,205.964406 344.035594,150 275,150 C205.964406,150 150,205.964406 150,275 C150,343.345238 204.850715,398.879405 272.932896,399.983254 L275,400 C425.359523,400 547.53469,520.671572 549.963158,670.452372 L550,675 L550,875 C550,1026.87831 426.878306,1150 275,1150 C124.640477,1150 2.46530954,1029.32843 0.0368421431,879.547628 L0,875 L0,675 C0,633.578644 33.5786438,600 75,600 C116.007143,600 149.327643,632.910429 149.989952,673.759738 L150,675 L150,875 C150,944.035594 205.964406,1000 275,1000 C343.345238,1000 398.879405,945.149285 399.983254,877.067104 L400,875 L400,675 C400,606.654762 345.149285,551.120595 277.067104,550.016746 L275,550 C123.121694,550 0,426.878306 0,275 C0,123.121694 123.121694,0 275,0 Z',
  'M275,200 C316.007143,200 349.327643,232.910429 349.989952,273.759738 L350.000013,275 L350.000013,358.696595 C325.924041,353.009436 300.813466,350 275,350 C233.578644,350 200,316.421356 200,275 C200,233.578644 233.578644,200 275,200 Z',
  'M199.999656,591.303327 C224.075728,596.990537 249.186415,600 275,600 C316.007143,600 349.327643,632.910429 349.989952,673.759738 L350,675 L350,875 L349.989952,876.240262 C349.327643,917.089571 316.007143,950 275,950 C233.992857,950 200.672357,917.089571 200.010048,876.240262 L199.999656,875 L199.999656,591.303327 Z'
]

export const getPath = (x, y) => translatePath(path, defaultX, defaultY, x, y)

const S = () => (
  <symbol id="s" viewBox={`${defaultX} ${defaultY} ${width} ${height}`}>
    <path d={path.join(' ')} />
  </symbol>
)

export default S
